import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from "lucide-react";

// The "contract" for our Modal's props.
export interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

export const Modal = ({ isOpen, onClose, children }: ModalProps) => {
    return (
        // Manages the animation when the modal enters and exits.
        <AnimatePresence>
            {isOpen && (
                // The semi-transparent backdrop.
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
                    onClick={onClose}
                >
                    {/* The main modal panel. */}
                    <motion.div
                        initial={{ y: -50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: 50, opacity: 0 }}
                        transition={{ type: 'spring', damping: 20, stiffness: 200 }}
                        className="relative bg-white rounded-xl p-8 text-center shadow-xl max-w-md w-full"
                        onClick={(e) => e.stopPropagation()} // Prevents backdrop click when clicking inside the modal.
                    >
                        {/* The 'X' close button. */}
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                        >
                            <X className="size-5" />
                        </button>

                        {/* Renders the content passed into the modal. */}
                        {children}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};